<template>
  <NuxtLoadingIndicator />
  <div class="flex min-h-screen flex-col bg-slate-50">
    <AppBar />
    <div>

      <Categories></Categories>
      <div class="flex flex-row mx-[18%]">
        <div class="w-[24%] mx-4">
          <Navbar></Navbar>
        </div>
        <div class="w-[75%] bg-white mt-2 border p-4 h-auto">
          <slot></slot>
        </div>
      </div>
    </div>
    <UNotifications />
    <LazyAppFooter />
  </div>
</template>

<script setup>
import { useCategoriesStore } from "~/stores/categories";

const categoryStore = useCategoriesStore();

categoryStore.setShouldDisplayImage(false)

// watch(user, (user, prevUser) => {
//   console.log('user-------sidebar--------' + user)
//   if (prevUser && !user) {
//     // user logged out
//     router.push('/login')
//   } else if (user && typeof route.query.redirect === 'string') {
//     // user logged in
//     router.push(route.query.redirect)
//   }
// })

</script>

<style>
body {
  font-family: 'Bitter', 'Open Sans', sans-serif;
}
</style>